import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, AlertController, ModalController } from 'ionic-angular';

import { TranslateService } from 'ng2-translate';

import { DashboardDetailsPage } from './dashboard-details/dashboard-details';

import { Dashboard, DashboardItem } from '../../model/top.model';

import { DashboardData } from '../../providers/dashboard-data';
import { ProjectData } from '../../providers/project-data';
import { EmployeeData } from '../../providers/employee-data';
import { TimeRegistrationData } from '../../providers/time-registration-data';

// import { TimeRegistrationsPage } from '../../pages/time-registrations/time-registrations';
import { EmployeeDetailsPage } from '../../pages/employees/employee-details/employee-details';

import { EditMode } from '../../enums/enums';

@Component({
  selector: 'page-dashboards',
  templateUrl: 'dashboards.html',
})
export class DashboardsPage {
  private dashboards: Array<Dashboard>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public menuCtrl: MenuController, private dashboardData: DashboardData, private projectData: ProjectData, private employeeData: EmployeeData, private timeRegistrationData: TimeRegistrationData, private alertCtrl: AlertController, private modalCtrl: ModalController, private translate: TranslateService) {
    menuCtrl.enable(true);
    this.dashboardData.getDashboards().then((result: Array<Dashboard>) => {
      this.dashboards = result;
    });
    // this.timeRegistrationData.getTimeRegistrations();
    // this.employeeData.getEmployees(false).then((result: Array<IEmployee>) => {
    //   this.projectData.getProjects().then((result: Array<IProject>) => {
    //     this.dashboardData.getDashboards().then((result: Array<Dashboard>) => {
    //       this.dashboards = result;
    //     });
    //   });
    // });
  }

  dashboardItemTapped(dashboardItem) {
    switch (dashboardItem.moduleName) {
      case 'timeRegistrationOverview':
        // this.employeeData.getEmployees(false).then((result: Array<IEmployee>) => {
          this.navCtrl.push(EmployeeDetailsPage, { isTimeRegistration: true });
        // });
        break;
      case 'timeRegistration':

        break;
      case 'leaveRegistrationOverview':

        break;
      case 'leaveRegistration':

        break;
    }
  }

  // newTimeRegistration() {
  //   let timeRegistrationModal = this.modalCtrl.create(TimeRegistrationModal, { employee: this.employeeData.loggedInEmployee, project_id: null });
  //   timeRegistrationModal.present();
  //   timeRegistrationModal.onDidDismiss(newTimeRegistration => {
  //     if (newTimeRegistration) {
  //       this.timeRegistrationData.createTimeRegistration(newTimeRegistration);
  //     }
  //   });
  // }

  addDashboard(event) {
    let newDashboard = new Dashboard(null, null, [{ uuid: "", dashboard_id: "", name: "" }] as DashboardItem[]);
    this.navCtrl.push(DashboardDetailsPage, {
      dashboard: newDashboard,
      editMode: EditMode.new
    });
  }

  deleteDashboard(event, dashboard) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('DELETE') + '?',
      subTitle: this.translate.instant('ARE_YOU SURE_DELETE', { value: '"' + dashboard.name + '"' }) + '?',
      cssClass: 'tv-delete-alert',
      buttons: [{
        text: this.translate.instant('NO')
      },
      {
        text: this.translate.instant('YES'),
        handler: data => {
          this.dashboardData.deleteDashboard(dashboard).then((result: Array<Dashboard>) => {
            // console.log(result);
          });
        }
      }]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboards/dashboards.ts